export default __webpack_public_path__ + "static/fantasticfoods-cecd2d1e01b6de9b94cef9006b652aed.png";